export const dummies = [
  {
    id: 1,
    title: '거창 오가네체리자두 3kg 한 상자',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20200715/236fbfcdd9cf2.jpg'],
    price: {
      regular: 36000,
      sale: 29000,
    },
    desc: '거창 오가네체리자두\n* 3kg 한상자 (50개 내외)\n* 7/28(목) 일괄 발송\n* 산지직송 무료배송',
    origin: 'Korea',
    shipping: {
      method: '택배',
      fee: '무료',
      info: '',
    },
    tag: [1, 3, 5],
    required: [],
    sale: true,
  },
  {
    id: 2,
    title: '무농약 GAP 인증 국산 청양 블루베리 2kg, 4kg, 5kg',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220622/24231acb3b26d.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/14552ecdda638.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/bd5f99cee136e.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/7e183dd36962b.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/8f2986621b7d6.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/05f824e3ca20a.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/8aae19266de14.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/86ef7e10d9f73.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/dcc1fcc2b4339.jpg',
    ],
    price: {
      regular: 120000,
      sale: 52000,
    },
    desc: '충남의 알프스라 불리는 청정지역 청양에서\n무농약으로 재배한 생 블루베리',
    origin: '충청남도 청양군',
    shipping: {
      method: '택배',
      fee: '무료 | 도서산간 배송비 추가',
      info: '제주, 도서지역 추가 4,000원',
    },
    tag: [1, 2, 4],
    required: ['필수선택', ['2kg', 52000], ['4kg', 92000], ['5kg', 109000]],
    sale: true,
  },
  {
    id: 3,
    title: '국산 강원도 화천 생 아스파라거스 1kg 2kg',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220622/420f289e15350.jpg'],
    price: {
      regular: 40000,
      sale: 30000,
    },
    desc: '미생물을 이용한 친환경 농법으로 길러 더욱 맛있는\n국내산 친환경 생 아스파라거스',
    origin: '강원도 화천군',
    shipping: {
      method: '택배',
      fee: '4,000원 (40,000원 이상 무료배송)',
      info: '',
    },
    tag: [1, 2],
    required: ['필수선택', ['1kg', 20000], ['2kg', 36000]],
    sale: true,
  },
  {
    id: 4,
    title: '목감기에 좋은 건더기 없는 프리미엄 수제 착즙 유자청',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220610/7902f9ea75514.jpg'],
    price: {
      regular: 15000,
      sale: 13300,
    },
    desc: '완도 바람 맞고 자란 비타민 가득 유자를 청으로 만나보세요!\n환절기에 딱! 목감기에 딱!\n건강한 유자로 맛있게 담근 청년 파머의 유자청',
    origin: '전라남도 완도',
    shipping: {
      method: '택배',
      fee: '3,500원 (50,000원 이상 무료배송)',
      info: '50,000원 이상 구매시 무료배송',
    },
    tag: [1, 2, 3],
    required: [
      '필수선택',
      ['유자청 480g 2병(960g)', 15200],
      ['유자청 1kg 1병', 13300],
      ['착즙유자 500ml', 18800],
    ],
    sale: true,
  },
  {
    id: 5,
    title: '돌다리농원 100% 예산 순수생사과즙 100포(50포x2BOX 묶음상품)',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220714/7a7034b864bd3.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/ffbe0a4ffa47d.jpeg',
    ],
    price: {
      regular: 60000,
      sale: 57000,
    },
    desc: '한 포로 챙기는 황금 사과!\n꿀보다 더 달달한 생사과즙으로 아침식사대용, 간식대용으로 하루의 건강과 달콤함을 챙겨보세요!',
    origin: '충청남도 예산',
    shipping: {
      method: '택배',
      fee: '무료 | 도서산간 배송비 추가',
      info: '제주, 도서지역 추가 4,000원',
    },
    tag: [1, 2],
    required: [],
    sale: true,
  },
  {
    id: 6,
    title: '반려동물과자 아기과자 동결건조 사과칩 50g (5봉지, 10봉지 묶음상품)',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220714/802daf8483428.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/5fd0cc3ed0fce.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/01c9f349309c9.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/e43ccd3949677.jpeg',
    ],
    price: {
      regular: 80000,
      sale: 35000,
    },
    desc: '달달함과 아삭함이 살아있는 껍찔째 먹는 동결건조 사과칩\n영양만점 간식으로 언제 어디서나 모두의 입맛에 딱!\nNO 제초제, NO 화학비료, NO 불필요한 잎따기를 철저히 지킨\n사과의 고장 충남 예산의 건강한 3무 사과를 껍찔째 즐겨보세요!',
    origin: '충청남도 예산',
    shipping: {
      method: '택배',
      fee: '무료 | 도서산간 배송비 추가',
      info: '제주, 도서지역 추가 4,000원',
    },
    tag: [1, 3],
    required: ['필수선택', ['5봉지', 35000], ['10봉지', 65000]],
    sale: true,
  },
  {
    id: 7,
    title: '100% 제주감귤주스 (15팩 x 1box)',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220521/69f390486a3e3.png'],
    price: {
      regular: 50000,
      sale: 22500,
    },
    desc: '감귤을 즐기는 색다른 방법, 100% 착즙으로 마시는 감귤\n제주 감귤이 고스란히 담긴 주스로 입맛도 돋우고, 건강도 지키세요!',
    origin: '제주특별자치도 서귀포시',
    shipping: {
      method: '택배',
      fee: '4,500원 (45,000원 이상 무료배송)',
      info: '45,000원 이상 구매시 무료배송',
    },
    tag: [1, 2],
    required: [],
    sale: true,
  },
  {
    id: 8,
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    price: {
      regular: 60000,
      sale: 22500,
    },
    desc: '감귤을 즐기는 색다른 방법!\n상큼함과 달달함이 고루 담겨진 바삭한 감귤칩을 만나보세요.\n영양은 그대로~ 언제 어디서나 맛 볼 수 있는 감귤과자!',
    origin: '제주특별자치도 서귀포시',
    shipping: {
      method: '택배',
      fee: '4,500원 (45,000원 이상 무료배송)',
      info: '45,000원 이상 구매시 무료배송',
    },
    tag: [1, 3],
    required: [],
    sale: true,
  },
  {
    id: 9,
    title: '청양 전통 수제 간장 500ml, 1L',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220622/cffd1aa63f3f9.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/be1433c679d82.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/e0e5cda8ff193.jpg',
    ],
    price: {
      regular: 16000,
      sale: 12500,
    },
    desc: '국내산 청양 콩으로 만들어 더욱 맛있고 건강한 수제 간장\n엄마의 마음으로 건강한 재료들을 엄선하고 준비하여 정성으로 담았습니다.',
    origin: '충청남도 청양군',
    shipping: {
      method: '택배',
      fee: '4,000원 (50,000원 이상 무료배송)',
      info: '40,000원 이상 구매시 무료배송',
    },
    tag: [1, 3],
    required: ['간장', ['간장 500ml', 6500], ['간장 1L', 12500]],
    sale: true,
  },
  {
    id: 10,
    title: '전통 재래식 메주로 띄운 수제 된장 1kg, 2kg',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220622/e1d8e149b8f58.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/29fd42b490ba3.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/e09dbb6d06bfc.jpg',
    ],
    price: {
      regular: 60000,
      sale: 19000,
    },
    desc: '국내산 청양 콩으로 만들어 더욱 맛있고 건강한 수제 된장\n엄마의 마음으로 건강한 재료들을 엄선하고 준비하여 정성으로 담았습니다.',
    origin: '충청남도 청양군',
    shipping: {
      method: '택배',
      fee: '4,000원 (50,000원 이상 무료배송)',
      info: '40,000원 이상 구매시 무료배송',
    },
    tag: [1, 3],
    required: ['필수선택', ['된장 1kg', 19000], ['된장 2kg', 37000]],
    sale: true,
  },
  {
    id: 11,
    title: '구기자 발효 수제 고추장 1kg, 2kg',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220622/7fae9ba860789.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/bbf4a6989371e.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/fec885830ef59.jpg',
    ],
    price: {
      regular: 70000,
      sale: 25000,
    },
    desc: '국내산 청양 콩으로 만들어 더욱 맛있고 건강한 수제 고추장\n엄마의 마음으로 건강한 재료들을 엄선하고 준비하여 정성으로 담았습니다.',
    origin: '충청남도 청양군',
    shipping: {
      method: '택배',
      fee: '4,000원 (50,000원 이상 무료배송)',
      info: '40,000원 이상 구매시 무료배송',
    },
    tag: [1, 3],
    required: ['선택필수', ['고추장 1kg', 25000], ['고추장 2kg', 49000]],
    sale: true,
  },
  {
    id: 12,
    title: '거창 오가네체리자두 3kg 한 상자',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20200715/236fbfcdd9cf2.jpg'],
    price: {
      regular: 36000,
      sale: 29000,
    },
    desc: '거창 오가네체리자두\n* 3kg 한상자 (50개 내외)\n* 7/28(목) 일괄 발송\n* 산지직송 무료배송',
    origin: 'Korea',
    shipping: {
      method: '택배',
      fee: '무료',
      info: '',
    },
    tag: [1, 3, 5],
    required: [],
    sale: true,
  },
  {
    id: 13,
    title: '무농약 GAP 인증 국산 청양 블루베리 2kg, 4kg, 5kg',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220622/24231acb3b26d.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/14552ecdda638.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/bd5f99cee136e.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/7e183dd36962b.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/8f2986621b7d6.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/05f824e3ca20a.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/8aae19266de14.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/86ef7e10d9f73.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/dcc1fcc2b4339.jpg',
    ],
    price: {
      regular: 120000,
      sale: 52000,
    },
    desc: '충남의 알프스라 불리는 청정지역 청양에서\n무농약으로 재배한 생 블루베리',
    origin: '충청남도 청양군',
    shipping: {
      method: '택배',
      fee: '무료 | 도서산간 배송비 추가',
      info: '제주, 도서지역 추가 4,000원',
    },
    tag: [1, 2, 4],
    required: ['필수선택', ['2kg', 52000], ['4kg', 92000], ['5kg', 109000]],
    sale: true,
  },
  {
    id: 14,
    title: '국산 강원도 화천 생 아스파라거스 1kg 2kg',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220622/420f289e15350.jpg'],
    price: {
      regular: 40000,
      sale: 30000,
    },
    desc: '미생물을 이용한 친환경 농법으로 길러 더욱 맛있는\n국내산 친환경 생 아스파라거스',
    origin: '강원도 화천군',
    shipping: {
      method: '택배',
      fee: '4,000원 (40,000원 이상 무료배송)',
      info: '',
    },
    tag: [1, 2],
    required: ['필수선택', ['1kg', 20000], ['2kg', 36000]],
    sale: true,
  },
  {
    id: 15,
    title: '목감기에 좋은 건더기 없는 프리미엄 수제 착즙 유자청',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220610/7902f9ea75514.jpg'],
    price: {
      regular: 15000,
      sale: 13300,
    },
    desc: '완도 바람 맞고 자란 비타민 가득 유자를 청으로 만나보세요!\n환절기에 딱! 목감기에 딱!\n건강한 유자로 맛있게 담근 청년 파머의 유자청',
    origin: '전라남도 완도',
    shipping: {
      method: '택배',
      fee: '3,500원 (50,000원 이상 무료배송)',
      info: '50,000원 이상 구매시 무료배송',
    },
    tag: [1, 2, 3],
    required: [
      '필수선택',
      ['유자청 480g 2병(960g)', 15200],
      ['유자청 1kg 1병', 13300],
      ['착즙유자 500ml', 18800],
    ],
    sale: true,
  },
  {
    id: 16,
    title: '돌다리농원 100% 예산 순수생사과즙 100포(50포x2BOX 묶음상품)',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220714/7a7034b864bd3.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/ffbe0a4ffa47d.jpeg',
    ],
    price: {
      regular: 60000,
      sale: 57000,
    },
    desc: '한 포로 챙기는 황금 사과!\n꿀보다 더 달달한 생사과즙으로 아침식사대용, 간식대용으로 하루의 건강과 달콤함을 챙겨보세요!',
    origin: '충청남도 예산',
    shipping: {
      method: '택배',
      fee: '무료 | 도서산간 배송비 추가',
      info: '제주, 도서지역 추가 4,000원',
    },
    tag: [1, 2],
    required: [],
    sale: true,
  },
  {
    id: 17,
    title: '반려동물과자 아기과자 동결건조 사과칩 50g (5봉지, 10봉지 묶음상품)',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220714/802daf8483428.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/5fd0cc3ed0fce.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/01c9f349309c9.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/e43ccd3949677.jpeg',
    ],
    price: {
      regular: 80000,
      sale: 35000,
    },
    desc: '달달함과 아삭함이 살아있는 껍찔째 먹는 동결건조 사과칩\n영양만점 간식으로 언제 어디서나 모두의 입맛에 딱!\nNO 제초제, NO 화학비료, NO 불필요한 잎따기를 철저히 지킨\n사과의 고장 충남 예산의 건강한 3무 사과를 껍찔째 즐겨보세요!',
    origin: '충청남도 예산',
    shipping: {
      method: '택배',
      fee: '무료 | 도서산간 배송비 추가',
      info: '제주, 도서지역 추가 4,000원',
    },
    tag: [1, 3],
    required: ['필수선택', ['5봉지', 35000], ['10봉지', 65000]],
    sale: true,
  },
  {
    id: 18,
    title: '100% 제주감귤주스 (15팩 x 1box)',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220521/69f390486a3e3.png'],
    price: {
      regular: 50000,
      sale: 22500,
    },
    desc: '감귤을 즐기는 색다른 방법, 100% 착즙으로 마시는 감귤\n제주 감귤이 고스란히 담긴 주스로 입맛도 돋우고, 건강도 지키세요!',
    origin: '제주특별자치도 서귀포시',
    shipping: {
      method: '택배',
      fee: '4,500원 (45,000원 이상 무료배송)',
      info: '45,000원 이상 구매시 무료배송',
    },
    tag: [1, 2],
    required: [],
    sale: true,
  },
  {
    id: 19,
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    price: {
      regular: 60000,
      sale: 22500,
    },
    desc: '감귤을 즐기는 색다른 방법!\n상큼함과 달달함이 고루 담겨진 바삭한 감귤칩을 만나보세요.\n영양은 그대로~ 언제 어디서나 맛 볼 수 있는 감귤과자!',
    origin: '제주특별자치도 서귀포시',
    shipping: {
      method: '택배',
      fee: '4,500원 (45,000원 이상 무료배송)',
      info: '45,000원 이상 구매시 무료배송',
    },
    tag: [1, 3],
    required: [],
    sale: true,
  },
  {
    id: 20,
    title: '청양 전통 수제 간장 500ml, 1L',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220622/cffd1aa63f3f9.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/be1433c679d82.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/e0e5cda8ff193.jpg',
    ],
    price: {
      regular: 16000,
      sale: 12500,
    },
    desc: '국내산 청양 콩으로 만들어 더욱 맛있고 건강한 수제 간장\n엄마의 마음으로 건강한 재료들을 엄선하고 준비하여 정성으로 담았습니다.',
    origin: '충청남도 청양군',
    shipping: {
      method: '택배',
      fee: '4,000원 (50,000원 이상 무료배송)',
      info: '40,000원 이상 구매시 무료배송',
    },
    tag: [1, 3],
    required: ['간장', ['간장 500ml', 6500], ['간장 1L', 12500]],
    sale: true,
  },
  {
    id: 21,
    title: '전통 재래식 메주로 띄운 수제 된장 1kg, 2kg',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220622/e1d8e149b8f58.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/29fd42b490ba3.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/e09dbb6d06bfc.jpg',
    ],
    price: {
      regular: 60000,
      sale: 19000,
    },
    desc: '국내산 청양 콩으로 만들어 더욱 맛있고 건강한 수제 된장\n엄마의 마음으로 건강한 재료들을 엄선하고 준비하여 정성으로 담았습니다.',
    origin: '충청남도 청양군',
    shipping: {
      method: '택배',
      fee: '4,000원 (50,000원 이상 무료배송)',
      info: '40,000원 이상 구매시 무료배송',
    },
    tag: [1, 3],
    required: ['필수선택', ['된장 1kg', 19000], ['된장 2kg', 37000]],
    sale: true,
  },
  {
    id: 22,
    title: '구기자 발효 수제 고추장 1kg, 2kg',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220622/7fae9ba860789.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/bbf4a6989371e.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/fec885830ef59.jpg',
    ],
    price: {
      regular: 70000,
      sale: 25000,
    },
    desc: '국내산 청양 콩으로 만들어 더욱 맛있고 건강한 수제 고추장\n엄마의 마음으로 건강한 재료들을 엄선하고 준비하여 정성으로 담았습니다.',
    origin: '충청남도 청양군',
    shipping: {
      method: '택배',
      fee: '4,000원 (50,000원 이상 무료배송)',
      info: '40,000원 이상 구매시 무료배송',
    },
    tag: [1, 3],
    required: ['선택필수', ['고추장 1kg', 25000], ['고추장 2kg', 49000]],
    sale: true,
  },
  {
    id: 23,
    title: '거창 오가네체리자두 3kg 한 상자',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20200715/236fbfcdd9cf2.jpg'],
    price: {
      regular: 36000,
      sale: 29000,
    },
    desc: '거창 오가네체리자두\n* 3kg 한상자 (50개 내외)\n* 7/28(목) 일괄 발송\n* 산지직송 무료배송',
    origin: 'Korea',
    shipping: {
      method: '택배',
      fee: '무료',
      info: '',
    },
    tag: [1, 3, 5],
    required: [],
    sale: true,
  },
  {
    id: 24,
    title: '무농약 GAP 인증 국산 청양 블루베리 2kg, 4kg, 5kg',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220622/24231acb3b26d.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/14552ecdda638.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/bd5f99cee136e.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/7e183dd36962b.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/8f2986621b7d6.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/05f824e3ca20a.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/8aae19266de14.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/86ef7e10d9f73.jpg',
      'https://cdn.imweb.me/thumbnail/20220622/dcc1fcc2b4339.jpg',
    ],
    price: {
      regular: 120000,
      sale: 52000,
    },
    desc: '충남의 알프스라 불리는 청정지역 청양에서\n무농약으로 재배한 생 블루베리',
    origin: '충청남도 청양군',
    shipping: {
      method: '택배',
      fee: '무료 | 도서산간 배송비 추가',
      info: '제주, 도서지역 추가 4,000원',
    },
    tag: [1, 2, 4],
    required: ['필수선택', ['2kg', 52000], ['4kg', 92000], ['5kg', 109000]],
    sale: true,
  },
  {
    id: 25,
    title: '국산 강원도 화천 생 아스파라거스 1kg 2kg',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220622/420f289e15350.jpg'],
    price: {
      regular: 40000,
      sale: 30000,
    },
    desc: '미생물을 이용한 친환경 농법으로 길러 더욱 맛있는\n국내산 친환경 생 아스파라거스',
    origin: '강원도 화천군',
    shipping: {
      method: '택배',
      fee: '4,000원 (40,000원 이상 무료배송)',
      info: '',
    },
    tag: [1, 2],
    required: ['필수선택', ['1kg', 20000], ['2kg', 36000]],
    sale: true,
  },
  {
    id: 26,
    title: '목감기에 좋은 건더기 없는 프리미엄 수제 착즙 유자청',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220610/7902f9ea75514.jpg'],
    price: {
      regular: 15000,
      sale: 13300,
    },
    desc: '완도 바람 맞고 자란 비타민 가득 유자를 청으로 만나보세요!\n환절기에 딱! 목감기에 딱!\n건강한 유자로 맛있게 담근 청년 파머의 유자청',
    origin: '전라남도 완도',
    shipping: {
      method: '택배',
      fee: '3,500원 (50,000원 이상 무료배송)',
      info: '50,000원 이상 구매시 무료배송',
    },
    tag: [1, 2, 3],
    required: [
      '필수선택',
      ['유자청 480g 2병(960g)', 15200],
      ['유자청 1kg 1병', 13300],
      ['착즙유자 500ml', 18800],
    ],
    sale: true,
  },
  {
    id: 27,
    title: '돌다리농원 100% 예산 순수생사과즙 100포(50포x2BOX 묶음상품)',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220714/7a7034b864bd3.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/ffbe0a4ffa47d.jpeg',
    ],
    price: {
      regular: 60000,
      sale: 57000,
    },
    desc: '한 포로 챙기는 황금 사과!\n꿀보다 더 달달한 생사과즙으로 아침식사대용, 간식대용으로 하루의 건강과 달콤함을 챙겨보세요!',
    origin: '충청남도 예산',
    shipping: {
      method: '택배',
      fee: '무료 | 도서산간 배송비 추가',
      info: '제주, 도서지역 추가 4,000원',
    },
    tag: [1, 2],
    required: [],
    sale: true,
  },
  {
    id: 28,
    title: '반려동물과자 아기과자 동결건조 사과칩 50g (5봉지, 10봉지 묶음상품)',
    imgUrl: [
      'https://cdn.imweb.me/thumbnail/20220714/802daf8483428.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/5fd0cc3ed0fce.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/01c9f349309c9.jpeg',
      'https://cdn.imweb.me/thumbnail/20220714/e43ccd3949677.jpeg',
    ],
    price: {
      regular: 80000,
      sale: 35000,
    },
    desc: '달달함과 아삭함이 살아있는 껍찔째 먹는 동결건조 사과칩\n영양만점 간식으로 언제 어디서나 모두의 입맛에 딱!\nNO 제초제, NO 화학비료, NO 불필요한 잎따기를 철저히 지킨\n사과의 고장 충남 예산의 건강한 3무 사과를 껍찔째 즐겨보세요!',
    origin: '충청남도 예산',
    shipping: {
      method: '택배',
      fee: '무료 | 도서산간 배송비 추가',
      info: '제주, 도서지역 추가 4,000원',
    },
    tag: [1, 3],
    required: ['필수선택', ['5봉지', 35000], ['10봉지', 65000]],
    sale: true,
  },
  {
    id: 29,
    title: '100% 제주감귤주스 (15팩 x 1box)',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220521/69f390486a3e3.png'],
    price: {
      regular: 50000,
      sale: 22500,
    },
    desc: '감귤을 즐기는 색다른 방법, 100% 착즙으로 마시는 감귤\n제주 감귤이 고스란히 담긴 주스로 입맛도 돋우고, 건강도 지키세요!',
    origin: '제주특별자치도 서귀포시',
    shipping: {
      method: '택배',
      fee: '4,500원 (45,000원 이상 무료배송)',
      info: '45,000원 이상 구매시 무료배송',
    },
    tag: [1, 2],
    required: [],
    sale: true,
  },
  {
    id: 30,
    title: '물에 타먹는 제주 수제 감귤칩(10봉지x1BOX)',
    imgUrl: ['https://cdn.imweb.me/thumbnail/20220520/873c30ce7d7f4.png'],
    price: {
      regular: 60000,
      sale: 22500,
    },
    desc: '감귤을 즐기는 색다른 방법!\n상큼함과 달달함이 고루 담겨진 바삭한 감귤칩을 만나보세요.\n영양은 그대로~ 언제 어디서나 맛 볼 수 있는 감귤과자!',
    origin: '제주특별자치도 서귀포시',
    shipping: {
      method: '택배',
      fee: '4,500원 (45,000원 이상 무료배송)',
      info: '45,000원 이상 구매시 무료배송',
    },
    tag: [1, 3],
    required: [],
    sale: true,
  },
];
